/**
 * Created by tong on 2018/1/31.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {openNotice} from 'Utils';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {sync, customerScreening, areaScreening, list} from '../../service/customerManagement';
/*获取列表数据,客户类型筛选,片区筛选接口*/
import {Store, Actions} from './store';

class CustomerManagement extends React.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            options: [],
            channel_type: [],
            rows: [],
            total: 0,
            searchObj: {
                name: '',
                code: '',
                channelType: '', /*渠道类型 筛选*/
                eareCode: '', /*片区编码 筛选*/
                p: 1,
                s: 10,
                account: this.userData.loginName,
                channelCode: this.channelData.split('|')[1] || ''
            },
            loading: true
        };
        this.syncChange = this.syncChange.bind(this);
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'customerManagement') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
        }
    };

    componentWillMount() { //准备数据
        const self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                }
            });
        }
        areaScreening().then(res => { //片区
            if (res.data && res.data.length > 0) {
                const data = res.data;
                data.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        item.children.forEach(element => {
                            element.value = item.value + '-' + element.value;
                        });
                    }
                });
                // console.log(data);
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({options: data});
                    }
                }, 0);
            }
        });
        customerScreening().then(res => { //客户类型
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channel_type: arr})
                    }
                }, 0);
            }
        })
    };

    componentDidMount() {
        this.mounted = true;
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*同步*/
    syncChange() {
        sync().then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '同步成功,请等待5分钟', '');
            } else {
                openNotice('error', '同步失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*筛选*/
    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                name: '',
                code: '',
                channelType: '', /*渠道类型 筛选*/
                eareCode: null, /*片区编码 筛选*/
                p: 0,
                s: 10,
            }, loading: true
        }, () => {
            self.getData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    /*获取列表数据*/
    getData() {
        const self = this;
        const {searchObj} = this.state;
        list(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false});
            }
        });
    };

    render() {
        const {rows, total, searchObj, options, channel_type, loading} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'name',
                    label: '客户名称',
                    text: '输入客户名称',
                    defaultValue: searchObj.name,
                    type: 'default'
                },
                {
                    name: 'code',
                    label: '客户编号',
                    text: '输入客户编号',
                    defaultValue: searchObj.code,
                    type: 'default'
                },
                // {
                //     name: 'channelType',
                //     label: '客户类型',
                //     text: '选择客户类型',
                //     options: channel_type,
                //     defaultValue: searchObj.channelType,
                //     multiple: false,//支持多选
                //     type: 'select'
                // },
                {
                    name: 'eareCode',
                    label: '片区',
                    text: '选择片区',
                    defaultValue: searchObj.eareCode !== null ? searchObj.eareCode + '' : '',
                    options: options,
                    showAll: false,
                    type: 'treeSelect',
                    dropdownStyle: {height: '400px', overflow: 'auto'}
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '客户编号',
                    dataIndex: 'code'
                }, {
                    title: '客户名称',
                    dataIndex: 'name',
                    render: (text, record, index) => {
                        return <a href={`#/customerManagement/${record.id}`}>{text}</a>
                    }
                }, /*{
                    title: 'TG产品权限',
                    dataIndex: 'tgFlag',
                    render: text => text === true ? '是' : '否'
                }, {
                    title: 'TGBZ产品权限',
                    dataIndex: 'tgbzFlag',
                    render: text => text === true ? '是' : '否'
                },*/ {
                    title: '所属片区',
                    dataIndex: 'areaName'
                }, {
                    title: '所属省市',
                    dataIndex: 'regionName'
                },
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={[`客户管理`]} defaultKey={0}>
                <Button icon="sync" onClick={this.syncChange}>同步</Button>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}

export default withRouter(CustomerManagement);


// WEBPACK FOOTER //
// ./src/routes/customerManagement/list.js